import { default as React, useCallback } from 'react'
import { useMatch } from 'react-router'
import { Avatar } from '@components/Avatar/Avatar'
import { Box, Button } from '@ui'
import { useCombinedAuth } from 'privy/useCombinedAuth'
import { CHANNEL_INFO_PARAMS, PATHS } from 'routes'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'
import { useConnectivity, useMyProfile } from 'use-towns-client'

export const ProfileCardButton = () => {
    const myProfile = useMyProfile()
    const userId = myProfile?.userId
    const isSpaceCreateRoute = useMatch(`${PATHS.SPACES}/new`)

    const { isAuthenticated } = useConnectivity()

    const { openPanel, closePanel, isPanelOpen } = usePanelActions()
    const onClick = useCallback(() => {
        isPanelOpen(CHANNEL_INFO_PARAMS.PROFILE)
            ? closePanel()
            : openPanel(CHANNEL_INFO_PARAMS.PROFILE, { profileId: 'me' })
    }, [closePanel, isPanelOpen, openPanel])

    const hasAvatar = isAuthenticated && userId
    const { login } = useCombinedAuth()

    return (
        <Box centerContent>
            {isAuthenticated ? (
                <Box
                    hoverable={!isSpaceCreateRoute}
                    cursor="pointer"
                    tooltip="Profile Info"
                    tooltipOptions={{ placement: 'horizontal' }}
                    onClick={onClick}
                >
                    {hasAvatar ? (
                        <Avatar size="avatar_x4" userId={userId} />
                    ) : (
                        <Box square="square_lg" background="level2" rounded="full" />
                    )}
                </Box>
            ) : (
                <Button
                    tone="lightHover"
                    rounded="full"
                    color="default"
                    size="button_sm"
                    onClick={login}
                >
                    Log In
                </Button>
            )}
        </Box>
    )
}
